import * as ko from 'knockout';

export class SecurityProfileModel {
	Main: KnockoutObservable<boolean>;

	constructor(public Id: number, public Name: string, main: boolean, public Image: string) {
		this.Main = ko.observable(main);
	}
}